import { render } from "./DropdownArrowIcon.vue?vue&type=template&id=dba198ea"
import script from "./DropdownArrowIcon.vue?vue&type=script&lang=js"
export * from "./DropdownArrowIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vdzeer/Projects/movesmart-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__